// Watchlist — team only. Deals worth a look, by rules that depend on stage.
//
// Replaces Top of Book, which ranked every active deal on days since its last
// logged stage change. That signal is wrong twice over for a deal in diligence
// (it sits in one stage for weeks by design) and for any deal loaded without a
// log entry. So: diligence is never flagged for sitting still, and a deal whose
// move into its current stage was never logged is counted, not guessed at.
import { STAGE_LABEL, WATCH_RULES } from "../../services/homeView";

export default function Watchlist({ watch, onOpenDeal }) {
  const { items, unaged } = watch;
  return (
    <section className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <h3 className="text-[15px] font-semibold text-[#f4f4f4]">Watchlist</h3>
      <p className="mt-0.5 text-[12px] text-[#8a8a8a]">Rules depend on stage — diligence runs on dates, not stage changes</p>

      <div className="mt-3">
        {items.length === 0 ? (
          <div className="py-4 text-[12.5px] text-[#8a8a8a]">Nothing flagged.</div>
        ) : items.map((w) => (
          <button key={w.row.id} onClick={() => onOpenDeal?.(w.row.deal)}
            className="grid w-full grid-cols-[1fr_auto] items-center gap-x-3 gap-y-1 border-b border-[#303030] py-3 text-left last:border-b-0 hover:bg-[#2c2c2c]">
            <span className="text-[13px] text-[#f4f4f4]">{w.row.name}</span>
            <span className="row-span-2 text-right text-[12px] font-semibold text-[#c8922f]">{w.age}</span>
            <span className="text-[11.5px] text-[#b4b4b4]">{STAGE_LABEL[w.row.stage]} · {w.why}</span>
          </button>
        ))}
      </div>

      <p className="mt-3 text-[10.5px] leading-relaxed text-[#7a7a7a]">
        Flags: underwriting past {WATCH_RULES.Underwriting} days · LOI unanswered past {WATCH_RULES["LOI Submitted"]} days · call for offers passed while still underwriting.
        {unaged > 0 && ` ${unaged} deal${unaged === 1 ? " has" : "s have"} no logged move into ${unaged === 1 ? "its" : "their"} current stage, so ${unaged === 1 ? "its" : "their"} age is unknown and not flagged.`}
      </p>
    </section>
  );
}
